/* 07/10/2026 (multidioma fase 2): textos desde window.N1T; los enlaces y títulos se reconocen en español o en el texto de su clave n1.*
   (n1.pdp.lk_*, n1.pdp.tech, n1.pdp.concept), y los acordeones de ajuste, descripción y cuidado primero por el id del bloque (fit, desc, care).
   N1 · Ficha de producto:
   1) enlaces destacados → popups existentes
   2) una sola sección abierta a la vez
   3) bloque suelto de Guía de tallas fuera
   4) móvil: “Ficha técnica” como acordeón idéntico a los del tema
   5) móvil y escritorio (30/09/2026): el vídeo (Unboxing · Así llega tu…) se coloca justo antes del bloque Concepto, en el mismo sitio en
      los dos (antes en escritorio quedaba después de todo, tras "Cuidado del guante")
   6) botón animado de Cuidado del guante
   11/10/2026 (7.8): el bloque suelto de Guía de tallas se busca solo fuera de los popups. Antes también encontraba el título «Guía de tallas»
      del popup del buscador (#n1k-gpop / #n1k-gsolo) y lo ocultaba; n1-pdp-size.js lo volvía a enseñar y, como cada segundo hay cambios en la
      página (cuenta atrás del pie), la guía parpadeaba en todos los idiomas. */
(function(){
if(window.N1PdpPop)return;window.N1PdpPop=1;
var T=function(k,d){var v=window.N1T&&window.N1T[k];return (typeof v==='string'&&v&&!/translation missing/i.test(v))?v:d},F=function(s,o){return String(s).replace(/\{(\w+)\}/g,function(m,k){return o&&o[k]!=null?o[k]:m})};
function rq(x){return String(x).replace(/[.*+?^${}()|[\]\\]/g,'\\$&')}
/* expresión que reconoce el texto en español o su traducción (clave n1.*) */
function rx(es,k){var t=T(k,es);return new RegExp(rq(es)+(t.toLowerCase()!==es.toLowerCase()?'|'+rq(t):''),'i')}
function lbls(es,k){var t=T(k,es).toLowerCase();return t!==es?[es,t]:[es]}

var css=''
+'.n1-plk{display:inline-flex;align-items:center;gap:.32rem;color:#fff!important;font-weight:600;text-decoration:none;border-bottom:1.5px solid #e4ee05;padding-bottom:1px;cursor:pointer}'
+'.n1-plk:hover{color:#e4ee05!important}'
+'.n1-plk svg{width:13px;height:13px;stroke:#e4ee05;fill:none;stroke-width:2.2;stroke-linecap:round;stroke-linejoin:round;flex:none}'
+'.n1-hidden-blk{display:none!important}'
/* 15/10/2026: los estilos de .n1-carebtn y del vídeo recolocado están ahora en assets/n1-pdp.css (se pintan en el servidor) */
;
var s=document.createElement('style');s.textContent=css;(document.head||document.documentElement).appendChild(s);

var ICON='<svg viewBox="0 0 24 24"><path d="M14 3h7v7"/><path d="M10 14L21 3"/><path d="M21 14v7H3V3h7"/></svg>';
var MAP=[
  {re:rx('información de envío','n1.pdp.lk_ship'), ship:true},
  {re:rx('cambios y devoluciones','n1.pdp.lk_returns'), url:'/pages/cambios-y-devoluciones', sel:'.n1a-content, .n1tp, .n1g'},
  {re:rx('condiciones de devolución','n1.pdp.lk_returns2'), url:'/pages/cambios-y-devoluciones', sel:'.n1a-content, .n1tp, .n1g'},
  {re:rx('guía de tallas','n1.pdp.lk_size'), url:'/pages/guia-de-tallas-guantes-de-portero', sel:'#tabla, .n1g, .n1a-content'},
  {re:rx('cuidado del guante','n1.pdp.lk_care'), url:'/pages/cuidado-del-guante', sel:'.n1a-content, .n1tp, .n1g'},
  {re:rx('personalización de guantes','n1.pdp.lk_perso'), url:'/pages/personalizacion', sel:'.n1a-content, .n1tp, .n1g'}
];
function scope(){return document.querySelector('.shopify-section--main-product, main')||document}
function openShip(){var b=document.querySelector('.n1-shiplink');if(b){b.click();return true}var p=document.getElementById('n1-pop-ship');if(p){p.classList.add('on');return true}return false}
function helpPop(url,sel){var a=document.createElement('a');a.href=url;a.setAttribute('data-n1pop',sel||'.n1a-content, .n1tp, .n1g');a.style.display='none';document.body.appendChild(a);a.click();setTimeout(function(){a.remove()},60)}
function linkify(){
  scope().querySelectorAll('p,li,dd,td').forEach(function(el){
    if(el.closest('a,.n1-carebtn,.n1pl,.n1-vp,nav,header,footer'))return;
    if(el.querySelector('a,.n1-plk'))return;
    for(var i=0;i<MAP.length;i++){
      var m=MAP[i].re.exec(el.textContent);if(!m)continue;
      var txt=m[0],w=document.createTreeWalker(el,NodeFilter.SHOW_TEXT,null),n;
      while((n=w.nextNode())){
        var idx=n.nodeValue.toLowerCase().indexOf(txt.toLowerCase());if(idx<0)continue;
        var after=n.splitText(idx);after.nodeValue=after.nodeValue.slice(txt.length);
        var a=document.createElement('a');a.className='n1-plk';a.href=MAP[i].ship?'#':MAP[i].url;
        if(MAP[i].ship)a.dataset.ship='1';else a.dataset.sel=MAP[i].sel;
        a.innerHTML=txt+ICON;
        a.addEventListener('click',function(ev){ev.preventDefault();if(this.dataset.ship){if(!openShip())location.href='/pages/envios'}else helpPop(this.getAttribute('href'),this.dataset.sel)});
        n.parentNode.insertBefore(a,after);break;
      }
      break;
    }
  });
}
function dropSizeBlock(){
  scope().querySelectorAll('h2,h3').forEach(function(h){
    if(h.closest('.n1k-kpop,.n1k,.n1-pop,.n1pl,[role="dialog"]'))return;
    var t=(h.textContent||'').trim().toLowerCase();
    if(t!=='guía de tallas'&&t!=='guia de tallas'&&lbls('guía de tallas','n1.pdp.lk_size').indexOf(t)<0)return;
    var box=h.parentElement,guard=0;
    while(box&&guard<4){
      if(box.querySelector('table')||lbls('mano (cm)','n1.size.hand_cm').some(function(x){return (box.textContent||'').toLowerCase().indexOf(x)>-1}))break;
      box=box.parentElement;guard++;
    }
    if(!box||box===document.body)box=h.parentElement;
    if(box.querySelector('.product-info,form[action*="/cart"]'))return;
    box.classList.add('n1-hidden-blk');
  });
}
/* una sola abierta */
document.addEventListener('toggle',function(e){
  var d=e.target;if(!d||d.tagName!=='DETAILS'||!d.open)return;
  var g=d.closest('.product-info');if(!g)return;
  g.querySelectorAll('details[open]').forEach(function(o){if(o!==d)o.open=false});
},true);
/* localizar el bloque de ficha técnica y el de concepto */
function blockByLabel(label){
  var head=null,ls=[].concat(label);
  scope().querySelectorAll('h2,h3,p,span,div').forEach(function(h){
    if(head||h.children.length)return;
    if(ls.indexOf((h.textContent||'').trim().toLowerCase())>-1)head=h;
  });
  if(!head)return null;
  var box=head.parentElement,guard=0;
  while(box&&guard<3){
    if(box.querySelector('table')||box.children.length>2)break;
    box=box.parentElement;guard++;
  }
  return box&&box!==document.body?box:null;
}
/* Ficha técnica: clonamos el HTML del acordeón vecino, pero con details/summary nativos */
function buildTech(){
  if(innerWidth>749)return;
  if(document.querySelector('details[data-n1tech]'))return;
  var tech=blockByLabel(lbls('ficha técnica','n1.pdp.tech').concat(['ficha tecnica']));
  if(!tech||tech.dataset.n1moved)return;
  /* acordeón modelo: por id de bloque (fit / desc); el texto queda de respaldo */
  var model=document.querySelector('.product-info__block-item[data-block-id="fit"] details')||document.querySelector('.product-info__block-item[data-block-id="desc"] details');
  if(!model)document.querySelectorAll('.product-info details').forEach(function(d){
    var sm=d.querySelector('summary');if(!sm)return;
    var t=(sm.textContent||'').trim().toLowerCase();
    if(t.indexOf('cómo se ajusta')===0||t.indexOf('descripción')===0)model=d;
  });
  if(!model)return;
  var host=model.closest('.product-info__block-item')||model;
  var wrap=document.createElement(host===model?'div':host.tagName.toLowerCase());
  if(host!==model)wrap.className=host.className;
  var det=document.createElement('details');det.className=model.className;det.setAttribute('data-n1tech','1');
  var sum=model.querySelector('summary').cloneNode(true);
  var lab=null;
  var w=document.createTreeWalker(sum,NodeFilter.SHOW_TEXT,null),n;
  while((n=w.nextNode())){if(n.nodeValue.trim()){lab=n;break}}
  if(lab)lab.nodeValue=T('n1.pdp.tech','Ficha técnica');
  det.appendChild(sum);
  var body=document.createElement('div');
  var mb=model.querySelector('summary').nextElementSibling;
  if(mb)body.className=mb.className;
  tech.dataset.n1moved='1';
  body.appendChild(tech);
  det.appendChild(body);
  if(host===model){wrap=det}else{wrap.appendChild(det)}
  host.parentNode.insertBefore(wrap,host.nextSibling);
}
/* móvil y escritorio: el vídeo va justo antes del bloque Concepto */
function placeVideo(){
  var vid=document.querySelector('.n1-pvideo');if(!vid)return;
  var sec=vid.closest('.shopify-section')||vid;
  if(sec.dataset.n1placed)return;
  var concepto=blockByLabel(lbls('concepto','n1.pdp.concept'));if(!concepto)return;
  var target=concepto;
  if(target.parentNode){sec.dataset.n1placed='1';target.parentNode.insertBefore(sec,target)}
}
function careButton(){
  var root=scope(),target=document.querySelector('.n1-perso')?document.querySelector('.product-info__block-item[data-block-id="care"] summary'):null,cl=lbls('cuidado del guante','n1.pdp.lk_care');
  if(!target)root.querySelectorAll('summary,h2,h3,.accordion__title').forEach(function(h){
    if(target)return;
    var tx=(h.textContent||'').trim().toLowerCase();
    if(cl.some(function(x){return tx.indexOf(x)===0}))target=h;
  });
  if(!target)return;
  var box=target.closest('details,.accordion,.product-info__block-item')||target.parentNode;
  if(box.dataset.n1care)return;box.dataset.n1care=1;
  var b=document.createElement('button');b.type='button';b.className='n1-carebtn';
  b.innerHTML='<span class="n1-carebtn__i"><svg viewBox="0 0 24 24"><path d="M12 3s6 5 6 10a6 6 0 0 1-12 0c0-5 6-10 6-10z"/><path d="M9.5 13.5c0 1.4 1.1 2.5 2.5 2.5"/></svg></span><span class="n1-carebtn__t"><b>'+T('n1.pdp.care_t','Cuidado del guante')+'</b><span>'+T('n1.pdp.care_s','Prelavado, limpieza y cómo alargar la vida del látex')+'</span></span><span class="n1-carebtn__go">›</span>';
  b.addEventListener('click',function(){helpPop('/pages/cuidado-del-guante')});
  box.parentNode.insertBefore(b,box);box.style.display='none';
}
/* 15/10/2026 (Bruno 03:48, punto 2 del bloque ficha): dropSizeBlock, placeVideo y careButton ya no se ejecutan. Movían u ocultaban bloques DESPUÉS de cargar y la ficha
   saltaba (vídeo Unboxing recolocado antes de Concepto, acordeón de Cuidado sustituido por el botón, bloque de Guía de tallas ocultado). Ahora lo pinta el servidor:
   sections/main-product.liquid (vídeo), snippets/product-info.liquid (botón de cuidado) y snippets/product-metafield-size-guide.liquid (sin tabla). Las funciones se
   conservan abajo sin uso por si hubiera que volver atrás. Siguen: linkify (enlaces en el texto, sin cambiar medidas) y buildTech (solo móvil). */
function run(){try{linkify()}catch(e){}try{buildTech()}catch(e){}}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
addEventListener('load',run);setTimeout(run,1000);setTimeout(run,2600);
new MutationObserver(function(){clearTimeout(window.__n1pp);window.__n1pp=setTimeout(run,450)}).observe(document.body,{childList:true,subtree:true});
})();